import { useQuery } from "@apollo/client";
import { GET_RANDOM_ORGANISATION_AD } from "./GET_RANDOM_ORGANISATION_AD.gql";
import { useOrganisation } from "components/providers/OrganisationProvider";
import {
    AdsQuery,
    AdsQueryVariables,
} from "./GET_RANDOM_ORGANISATION_AD.gql.types";

export function useRandomAd() {
    const organisation = useOrganisation();
    const { data, loading, error } = useQuery<AdsQuery, AdsQueryVariables>(
        GET_RANDOM_ORGANISATION_AD,
        {
            variables: { organisationId: organisation?.id },
            skip: !organisation,
        },
    );

    if (loading || error || !data?.randomAd) {
        return null;
    }

    return data.randomAd;
}
